import { DOORBELL_INSTALLATION_HELP_URL } from "../../../../native/geeni/js/constants";

const installationInstructions = {
  powerDevice: {
    currentStep: "powerDevice",
    nextStep: "confirmPairingMode",
    nextStepName: "categoryInstructions",
    prevStepName: "https://return-to-app",
    headerOverridingClass: "background-gray",
    resource: require("@/assets/categories/doorbell/doorbell_power.png"),
    resourceType: "image",
    primaryTx: "categories.doorbell.powerDevice.title",
    secondaryTx: "categories.doorbell.powerDevice.subtitle",
    continueButtonTx: "common.continue",
    alternateNextStep: {
      titleTx: "categories.doorbell.onlineInstructions",
      link: DOORBELL_INSTALLATION_HELP_URL,
    },
  },
  confirmPairingMode: {
    currentStep: "confirmPairingMode",
    prevStep: "powerDevice",
    prevStepName: "categoryInstructions",
    headerOverridingClass: "background-gray",
    resource: require("@/assets/categories/doorbell/doorbell_pairing_mode.png"),
    resourceType: "image",
    primaryTx: "categories.doorbell.confirmPairingMode.title",
    secondaryTx: "categories.doorbell.confirmPairingMode.subtitle",
    isLastPage: true,
    lastPageExitUrl: "https://www.exit-installation-instructions-flow",
    primaryActionKey: "chooseProvider",
    continueButtonTx: "common.continue",
    alternateNextStep: {
      titleTx: "categories.doorbell.stepsToReset",
      nextStep: "resetDevice",
      nextStepName: "categoryInstructions",
      lastStep: "confirmPairingMode",
    },
  },
  resetDevice: {
    headerIcon: "closeBlack",
    prevStep: "powerDevice",
    prevStepName: "categoryInstructions",
    currentStep: "resetDevice",
    nextStep: "confirmPairingMode",
    nextStepName: "categoryInstructions",
    headerOverridingClass: "background-gray",
    headerTitleTx: "categories.doorbell.stepsToReset",
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: "image",
          resource: require("@/assets/categories/doorbell/reset_doorbell_step_1.png"),
          primaryTx: "categories.doorbell.resetDevice.step1.title",
          secondaryTx: "categories.doorbell.resetDevice.step1.subtitle",
        },
        {
          resourceType: "image",
          resource: require("@/assets/categories/doorbell/reset_doorbell_step_2.png"),
          primaryTx: "categories.doorbell.resetDevice.step2.title",
          secondaryTx: "categories.doorbell.resetDevice.step2.subtitle",
        },
        {
          resourceType: "image",
          resource: require("@/assets/categories/doorbell/reset_doorbell_step_3.png"),
          primaryTx: "categories.doorbell.resetDevice.step3.title",
          secondaryTx: "categories.doorbell.resetDevice.step3.subtitle",
        },
      ],
    },
  },
};

export default installationInstructions;
